// extracted by mini-css-extract-plugin
export default {"belowLabel":"SecurityNotice_belowLabel__O8tB1","notice":"SecurityNotice_notice__DGhlk","icon":"SecurityNotice_icon__2wK5T","text":"SecurityNotice_text__Ofcjl"};